let navigate = null;

export const setNavigate = (nav) => {
    navigate = nav;
};

export const navigateTo = (path, options = {}) => {
    if (navigate) {
        navigate(path, options);
    }
};